import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Box,
    Link,
    useTheme
} from '@mui/material';

interface RecentActivityCardProps {
    title?: string;
    mainMessage: string;
    secondaryMessage?: string;
    date?: string;
    linkText?: string;
    onViewAllClick?: () => void;
}

const RecentActivityCard: React.FC<RecentActivityCardProps> = ({
    title = "Actividad reciente",
    mainMessage,
    secondaryMessage,
    date = new Date().toLocaleString('es-ES', {
        hour: '2-digit',
        minute: '2-digit',
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    }),
    linkText = "Ver toda la actividad",
    onViewAllClick
}) => {
    const theme = useTheme();

    return (
        <Card
            sx={{
                borderRadius: '16px',
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.06)',
                width: '100%'
            }}
        >
            <CardContent sx={{ padding: 3, position: 'relative' }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        mb: 2
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h2"
                        sx={{
                            fontWeight: 'bold',
                            fontSize: { xs: '1.75rem', sm: '2rem' }
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            fontSize: '0.875rem',
                            mt: 0.5
                        }}
                    >
                        {date}
                    </Typography>
                </Box>
                <Typography
                    variant="h3"
                    component="div"
                    sx={{
                        fontWeight: 'medium',
                        mb: 1,
                        fontSize: { xs: '1.3rem', sm: '1.5rem' }
                    }}
                >
                    {mainMessage}
                </Typography>
                {secondaryMessage && (
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ mb: 1 }}
                    >
                        {secondaryMessage}
                    </Typography>
                )}

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mt: 2
                    }}
                >
                    <Link
                        component="button"
                        variant="body1"
                        onClick={onViewAllClick}
                        underline="hover"
                        sx={{
                            color: theme.palette.primary.main,
                            fontWeight: 'medium',
                            cursor: 'pointer'
                        }}
                    >
                        {linkText}
                    </Link>
                </Box>
            </CardContent>
        </Card>
    );
};

export default RecentActivityCard;